import { render, staticRenderFns } from "./TagsSelectorModal.vue?vue&type=template&id=ee1ace72&scoped=true"
import script from "./TagsSelectorModal.vue?vue&type=script&lang=js"
export * from "./TagsSelectorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1ace72",
  null
  
)

export default component.exports